import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import { useProfileQuery } from "../services/userService";

export default function AppLayout({ userType }) {
    const { data: profileData } = useProfileQuery();
    let user = profileData?.data || null;
    const location = useLocation();

    const navigate = useNavigate();
    useEffect(() => {
        if (location.pathname === "/") {
            navigate("/signin");
        }
        if (user) {
            if (
                user?.reg_status === "CREATED" ||
                user?.reg_status === "INVITED"
            ) {
                navigate("/onboarding");
            } else {
                navigate(location.pathname);
            }
        }
    }, [user, location.pathname, navigate]);

    return (
        <>
            <Navbar user={user} />
            <div className="container-fluid">
                <main style={{ paddingTop: "60px" }}>
                    {/* //Todo: Add breadcrumbs */}
                    {user !== null && <Outlet />}
                </main>
            </div>
        </>
    );
}
